import { render, staticRenderFns } from "./communications.vue?vue&type=template&id=4fb0c0da&scoped=true&"
import script from "./communications.vue?vue&type=script&lang=js&"
export * from "./communications.vue?vue&type=script&lang=js&"
import style0 from "./communications.vue?vue&type=style&index=0&id=4fb0c0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0c0da",
  null
  
)

export default component.exports